import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  internalTransfers: { ...initialStateList },
  destinationMerchantIdTypes: [],
  commercialRelationships: { ...initialStateList },
};
export const InternalTransfers = handleActions({ ...GridFilters }, initialState);

const getInternalTransfers = (state) => state.InternalTransfers;

export const getDestinationMerchantIdTypes = createSelector(getInternalTransfers, (state) => state.commercialRelationships.data);

export const getInternalTransfersList = (state, list) => {
  const internalTransfers = getInternalTransfers(state);
  return internalTransfers[list] || undefined;
};
export const getCommercialRelationshipsList = (state, list) => {
  const commercialRelationships = getInternalTransfers(state);
  return commercialRelationships[list] || undefined;
};
